import { GetServerSidePropsContext } from 'next';
import styled from 'styled-components';
import { SleepyCatIcon } from 'assets/svg';

type ErrorPageProps = {
  message?: string;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { message } = context.query;

  return {
    props: {
      message: message || 'Something went wrong.',
    },
  };
}

export default function ErrorPage({ message }: ErrorPageProps) {
  return (
    <PageWrap>
      <CenterContent>
        <SleepyCatIcon />
      </CenterContent>
      <h5>{message || 'Microsite Not Available'}</h5>
    </PageWrap>
  );
}

const PageWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const CenterContent = styled.div`
  margin-bottom: 1rem;
`;
